// Linter doesn't like catch in the zod schemas. But this works and is a lot more readable.
/* eslint-disable unicorn/prefer-top-level-await */

import { z } from 'zod'
import { catchWithSentryCapture } from '../utils'

export const OFFICE_ACTION_SORT_FIELDS = [
  'code',
  'description',
  'category',
  'frequency',
  'rank',
] as const

export const officeActionEventSchema = z.string().min(1)

export const officeActionSchema = z.object({
  rank: z.number(),
  code: z.string(),
  description: z.string(),
  frequency: z.number(),
  category: z.string(),
  details: z.string(),
})

export type OfficeAction = z.infer<typeof officeActionSchema>

export const SORT_DIRECTIONS = ['asc', 'desc'] as const

export const officeActionSortFieldSchema = z
  .enum(OFFICE_ACTION_SORT_FIELDS)
  .optional()
  .default('rank')
  .catch(catchWithSentryCapture('rank' as const, 'officeActionSortFieldSchema'))

export const sortDirectionSchema = z
  .enum(SORT_DIRECTIONS)
  .optional()
  .default('asc')
  .catch(catchWithSentryCapture('asc' as const, 'sortDirectionSchema'))

export const officeActionsSearchParametersSchema = z.object({
  office_actions_order_by: officeActionSortFieldSchema,
  office_actions_order_direction: sortDirectionSchema,
})

export type OfficeActionSortField = z.infer<typeof officeActionSortFieldSchema>
export type SortDirection = z.infer<typeof sortDirectionSchema>
export type OfficeActionEvent = z.infer<typeof officeActionEventSchema>
export type OfficeActionsSearchParameters = z.infer<
  typeof officeActionsSearchParametersSchema
>
